<app-banner [isCommonBanner]="true" [isDefaultPageBanner]="false" [banner]="banner"></app-banner>
<app-left-side-menu-known-issues [pageTitle]="pageTitle"></app-left-side-menu-known-issues>
